export default function ChatLoader() {
    return (
        <div className="flex h-full items-center justify-center">
            <div className="flex flex-col gap-4 h-[90%] w-full items-center justify-center rounded-xl">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        </div>
    );
}